<template>
  <div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
      <div
        class="panel panel-default"
        style="border: 1px solid #ccc; background-color: white"
      >
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="javascript://void(0)" @click="toggleShowAll">
              <i
                v-if="collapseSection"
                class="fa fa-angle-right"
                aria-hidden="true"
              ></i>
              <i v-else class="fa fa-angle-down" aria-hidden="true"></i>
              {{ this.status_name }} ({{ this.priceIntervals.length }})
            </a>
          </h4>
        </div>
        <div
          class="panel-collapse"
          :class="{ collapse: this.collapseSection }"
          style="background-color: white"
        >
          <div class="panel-body" style="background-color: white">
            <div
              v-for="priceInterval in this.priceIntervals"
              :key="priceInterval.Id"
            >
              <div class="row">
                <core-price-interval
                  :price_interval_id="priceInterval.Id"
                  :price_interval = "priceInterval"
                  :show_community="true"
                ></core-price-interval>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status_name: {
      required: true,
      type: String,
    },
    status_id: {
      required: true,
      type: Number,
    },
    package_price_type_id: {
      required: false,
      type: String,
    },
    company_id: {
      required: false,
      type: String,
    },
    csm: {
      required: false,
      type: String,
    },
    leadTime: {
      required: false,
      type: Number,}
  },
  watch: {
    // This would be called anytime the value of title changes
    package_price_type_id: function (newVal, oldVal) {
      console.log(
        "package_price_type_id changed from " +
          oldVal +
          " to " +
          newVal +
          ":" +
          this.package_price_type_id
      );
      this.loading = true;
      this.loadPriceInterval()
        .catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
    company_id: function (newVal, oldVal) {
      console.log(
        "company_id changed from " +
          oldVal +
          " to " +
          newVal +
          ":" +
          this.company_id
      );
      this.loading = true;
      this.loadPriceInterval()
        .catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
    csm: function (newVal, oldVal) {
      console.log(
        "csm changed from " + oldVal + " to " + newVal + ":" + this.csm
      );
      this.loading = true;
      this.loadPriceInterval()
        .catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
    leadTime: function (newVal, oldVal) {
      console.log(
        "leadTime changed from " + oldVal + " to " + newVal + ":" + this.csm
      );
      this.loading = true;
      this.loadPriceInterval()
        .catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadPriceInterval()
      .catch(this.$root.handleErrors)
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    loadPriceInterval() {
      console.log("loadPriceInterval");
      var url = "/core/priceInterval/byStatus/" + this.status_id;
      // var params = {'packagePriceType':this.package_price_type_id
      // ,'companyId':this.company_id
      // ,'csm':this.csm};
      console.log(url);
      return axios.get(url,{ params: {
  'package_price_type_id' :this.package_price_type_id,
  'company_id':this.company_id,
  'csm':this.csm,
  'leadTime':this.leadTime
}}).then((response) => {
        console.log(response.data.PriceIntervals);
        this.$set(this, "priceIntervals", response.data.PriceIntervals);
        this.loading = false;
      });
    },
    toggleShowAll() {
      this.collapseSection = !this.collapseSection;
    },
  },
  computed: {},
  data() {
    return {
      collapseSection: true,
      loading: true,
      priceIntervals: null,
    };
  },
};
</script>
